<template>
  <v-expansion-panels flat class="esocial-campos">
    <v-expansion-panel>
      <v-expansion-panel-header class="px-0">
        <span>
          <v-icon left small>mdi-file-xml-box</v-icon>
          eSocial
          <span class="text-caption text--secondary ml-1">
            (envio de admissões e alterações contratuais)
          </span>
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="text-caption text--secondary mb-3">
          O S-2200 e o S-2206 de empregado exigem o CNPJ do sindicato da
          categoria profissional.
        </div>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              :value="recurso.cnpj"
              @input="definir('cnpj', $event ? $event.toUpperCase() : null)"
              label="CNPJ do sindicato"
              v-mask="'NN.NNN.NNN/NNNN-##'"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              :value="recurso.mesDataBase"
              @change="definir('mesDataBase', $event)"
              :items="meses"
              label="Mês da data-base da categoria"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import { MESES } from "./esocialTabelas";
export default {
  name: "CamposEsocialSindicato",
  props: { recurso: { type: Object, required: true } },
  data() {
    return { meses: MESES };
  },
  methods: {
    definir(campo, valor) {
      this.$set(this.recurso, campo, valor === "" ? null : valor);
    },
  },
};
</script>
